// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__PoouN","title":"card_title__3grq5","inActive":"card_inActive__isXYU"};